import { useQuery } from "@tanstack/react-query";

import { homeQueryKeys } from "@/features/home/api/queryKeys";
import { instance } from "@/lib/axios/instance";

interface ActiveCampaignIntegrationCountResponse {
  count: number;
}

/**
 * Count of integrations that have the campaigns module enabled AND at least one
 * campaign currently running. Scope:
 *   - No `clientId`: caller's JWT-derived client/tenant scope.
 *   - `clientId` provided: admin/superadmin override for /clients/:clientId/home.
 *     The backend ignores the param for non-admin callers.
 */
export function useActiveCampaignIntegrationCount(clientId?: string) {
  const query = useQuery({
    queryKey: homeQueryKeys.activeCampaignIntegrationCount(clientId),
    queryFn: async () => {
      const res = await instance.get<ActiveCampaignIntegrationCountResponse>(
        "/api/v2/Home/active-campaign-integration-count",
        { params: { clientId: clientId || undefined } },
      );
      return res.data;
    },
    staleTime: 10 * 60 * 1000,
  });

  return {
    count: query.data?.count ?? null,
    isLoading: query.isPending,
    isError: query.isError,
  };
}
